/**
 * @lodex-pro/web-portal/hooks/useDisposalMagicLinkConsumeMutation — TanStack Query
 * mutation hook wrapping publicApi.disposalMagicLinkConsume (DEC-160).
 *
 * Mirrors useMagicLinkConsumeMutation. Uses bare `useMutation` — no auth headers.
 * NOTE: captchaToken NOT required (removed per DEC-155 grey area 2; DEC-156 §5
 * kept the same posture for the disposal consume endpoint).
 */

import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { disposalMagicLinkConsume, type PublicApiError } from '../public/publicApi';
import type {
  DisposalMagicLinkConsumeRequest,
  DisposalMagicLinkConsumeResponse,
} from '@lodex-pro/shared/validation/disposal-portal';

export function useDisposalMagicLinkConsumeMutation(): UseMutationResult<
  DisposalMagicLinkConsumeResponse,
  PublicApiError,
  DisposalMagicLinkConsumeRequest
> {
  return useMutation<
    DisposalMagicLinkConsumeResponse,
    PublicApiError,
    DisposalMagicLinkConsumeRequest
  >({
    mutationFn: (body) => disposalMagicLinkConsume(body),
  });
}
